import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import { Separator } from '@/components/ui/separator';
import { Card, CardContent } from '@/components/ui/card';

import { AddedMembers, OrganizationMembers } from './';

type Props = {
  noteText: string;
};

const MembersManagementContainer = ({ noteText }: Props) => {
  return (
    <SoftwareOnboardingMain
      title="Add members to your escrow"
      description="Add team members to this escrow and set their permissions. Their permissions affect how they can contribute to the escrow."
      noteText={noteText}
      classes={{ note: 'not-italic', wrapper: 'md:h-full min-h-[600px]' }}
    >
      <div className="container mx-auto grow md:overflow-hidden">
        <Card className="h-full">
          <CardContent className="h-full py-6 px-0 grid gap-6 md:gap-0 grid-cols-1 md:grid-cols-[1fr_1px_1fr]">
            <AddedMembers />
            <Separator orientation="vertical" className="hidden md:block" />
            <div className="block md:hidden px-6">
              <Separator orientation="horizontal" />
            </div>
            <OrganizationMembers />
          </CardContent>
        </Card>
      </div>
    </SoftwareOnboardingMain>
  );
};

export default MembersManagementContainer;
